import clsx from "clsx";
import { GroupIcon } from "../../../GroupIcon";
import type { DestinationIconProps } from "./types";

export const DestinationIcon = ({
  dataUrl,
  title,
  size = "sm",
}: DestinationIconProps) => {
  if (dataUrl)
    return (
      <span title={title} className="inline-flex">
        <GroupIcon dataUrl={dataUrl} size={size} disableHover />
      </span>
    );

  return (
    <span
      title={title}
      className={clsx(
        "inline-flex shrink-0 items-center justify-center rounded border border-gray-200 bg-slate-50",
        size === "xs" ? "h-6 w-6" : "h-8 w-8",
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />
    </span>
  );
};
